import * as React from 'react';

import { CodeRejet, useAchatsService, useSociete } from '@europrocurement/l2d-domain';
import { getDataThunkType } from '@europrocurement/l2d-redux-utils';
import { AxiosPromise } from 'axios';
import { NamedAxiosPromise } from '@europrocurement/flexy-components/types/NamedAxiosPromise';
import LabeledAsyncSwitch from './LabeledAsyncSwitch';

/**
 * Manages the automatic reminder (relance active) toggle for a reject code
 *
 * @component
 * @param {Object} props - Component properties
 * @param {CodeRejet} props.rejectCode - The current reject code object
 * @param {getDataThunkType<CodeRejet>} props.fetchData - Function to refresh data after toggle
 * @param {boolean} [props.disabled] - Flag to disable the toggle
 */
const AsyncSwitchRejectCodeRelanceAuto: React.FunctionComponent<{
    rejectCode: CodeRejet;
    fetchData: getDataThunkType<CodeRejet>;
    disabled?: boolean;
}> = function ({ rejectCode, fetchData, disabled }) {
    const xIdSociete = useSociete();

    const { codeRejetApi } = useAchatsService();

    /**
     * Creates a toggle request for the relanceAuto field
     *
     * @returns {NamedAxiosPromise[]} Array of named promises for updating the reject code
     */
    const createToggleRequest = (): NamedAxiosPromise[] => {
        if (!rejectCode.code) return [];

        return [
            {
                name: 'updateRejectCodeRelanceAuto',
                promise: codeRejetApi.patchCodeRejetItem({
                    code: rejectCode.code,
                    codeRejetCodeRejetUpdate: {
                        relanceAuto: !rejectCode.relanceAuto,
                    },
                    xIdSociete,
                }) as AxiosPromise,
            },
        ];
    };

    return (
        <LabeledAsyncSwitch
            key={`${rejectCode.code}-relanceAuto_${rejectCode.relanceAuto}`}
            requestsOnToggle={createToggleRequest}
            fetchData={fetchData}
            defaultChecked={rejectCode.relanceAuto}
            disabled={disabled}
            validationModal
        />
    );
};

export default AsyncSwitchRejectCodeRelanceAuto;
